export default "__VITE_ASSET__DEgcFH5H__"